// extracted by mini-css-extract-plugin
module.exports = {"scrollContainer":"Tournaments_scrollContainer__UuA2d","error":"Tournaments_error__2D9G5"};